/**
 * Contact Us slide-over drawer.
 */
(function () {
  var drawer = document.querySelector("[data-contact-drawer]");
  if (!drawer) return;

  var infoView = drawer.querySelector('[data-contact-view="info"]');
  var formView = drawer.querySelector('[data-contact-view="form"]');

  function showView(name) {
    if (infoView) infoView.hidden = name !== "info";
    if (formView) formView.hidden = name !== "form";
  }

  function openDrawer(showForm) {
    showView(showForm ? "form" : "info");
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  function getPath(href) {
    if (!href || href === "#") return "";
    try {
      return new URL(href, window.location.origin).pathname.replace(/\/+$/, "") || "/";
    } catch (e) {
      return href.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
    }
  }

  function isContactPath(path) {
    return /^\/pages\/contact(-us)?$/i.test(path) || path === "/contact";
  }

  function isContactLink(el) {
    if (!el || el.tagName !== "A") return false;
    if (el.hasAttribute("data-contact-page")) return false;
    if (el.hasAttribute("data-contact-open")) return true;

    var path = getPath(el.getAttribute("href"));
    if (isContactPath(path)) return true;

    var text = (el.textContent || "").trim().toLowerCase();
    if ((text === "contact" || text === "contact us") && path.indexOf("/pages/") === 0) {
      return true;
    }

    return false;
  }

  function isContactPage() {
    if (drawer.getAttribute("data-auto-open") === "true") return true;
    return document.body.classList.contains("page-contact") || document.body.classList.contains("page-contact-us");
  }

  document.addEventListener("click", function (e) {
    var openLink = e.target.closest("a");
    if (openLink && isContactLink(openLink)) {
      e.preventDefault();
      openDrawer(false);
      return;
    }

    if (e.target.closest("[data-contact-show-form]")) {
      e.preventDefault();
      showView("form");
      return;
    }

    if (e.target.closest("[data-contact-show-info]")) {
      e.preventDefault();
      showView("info");
      return;
    }

    if (e.target.closest("[data-contact-close]")) {
      e.preventDefault();
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  function init() {
    if (drawer.querySelector(".contact-form__success")) {
      openDrawer(true);
      return;
    }
    if (isContactPage()) {
      openDrawer(false);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.WearableContactDrawer = {
    open: openDrawer,
    close: closeDrawer,
  };
})();
